import {NameValues} from '@/modules/neodash/model/types/interfaces/NameValue';
import {i18nMixin} from '@/modules/neodash/mixins';

export const listAllMarketSummaryPeriods = (): NameValues => [
  { 'key': 'LastYear', 'value': 1 },
  { 'key': 'ThisYear', 'value': 2 },
  { 'key': 'TwelveMonths', 'value': 3 }
].map(({key, value}) => ({
  name: i18nMixin.methods.i18n(`Filters.Periods.${key}`),
  value
}));

export const listAllMarketAnalysisReferences = () => [
  { 'key': 'Country', 'value': 1 },
  { 'key': 'Region', 'value': 2 },
  { 'key': 'State', 'value': 3 },
  { 'key': 'Comparison', 'value': 4 },
  { 'key': 'TopThree', 'value': 5 },
  { 'key': 'Area', 'value': 6 }
].map(({key, value}) => ({
  name: i18nMixin.methods.i18n(`Filters.MarketShareReferences.${key}`),
  value
}));
